import React, { useMemo } from "react";
import { BUILDER_GUIDE } from "config/constant";
import { Content } from "@/layout";
import { Icon } from "@/components";
import { Panel, Heading, Text, Link, Button } from "@/ui";
import { useStoreContext } from "context";
import styles from "./BuilderGuide.module.scss";

const BuilderGuide = () => {
    // const total = 8;
    // const progress = 5;
    const { externalUrls } = useStoreContext();

    const { prismicHomeURL, prismicPromoURL, prismicNavigationURL } =
        useMemo(() => {
            return {
                prismicHomeURL: externalUrls?.prismicHomeURL,
                prismicPromoURL: externalUrls?.prismicPromoURL,
                prismicNavigationURL: externalUrls?.prismicNavigationURL,
            };
        }, [externalUrls]);

    /* const handlerCompleted = (e, topic) => {
        if (topic?.completed) {
            return;
        }
    }; */

    const getLink = link => {
        if (!["homepage", "seo", "promo", "navigation"].includes(link)) {
            return link;
        }

        if (link === "homepage") {
            return prismicHomeURL;
        }

        if (link === "promo") {
            return prismicPromoURL;
        }

        if (link === "navigation") {
            return prismicNavigationURL;
        }

        return `${prismicHomeURL}?section=SEO`;
    };

    return (
        /* Legacy class names kept as Pendo CSS selector hooks. */
        <Content className={`${styles.container} guide-container`}>
            <div className={`${styles.grid} k-content-grid-two-column`}>
                <Panel
                    className={`${styles.progressPanel} k-content-section-progress`}
                    density="comfortable"
                >
                    {/* <Heading level={4}>Mark your progress</Heading>
                    <Text tone="secondary" variant="body-sm">
                        Make sure to complete your store setup at every step.
                    </Text>
                    <Progress
                        fullWidth
                        max={total}
                        value={progress}
                    />
                    <span className={styles.progressSeparator} /> */}
                    <div className={styles.progressBody}>
                        <Heading className={styles.cardTitle} level={4}>
                            {BUILDER_GUIDE?.titleSectionOther}
                        </Heading>
                        <Text tone="secondary" variant="body-sm">
                            {BUILDER_GUIDE?.descriptionSectionOther}
                        </Text>
                        <ul className={styles.linkList}>
                            {BUILDER_GUIDE?.linksSectionOther?.map(
                                (link, index) => {
                                    return (
                                        <li key={index}>
                                            <Button
                                                className={styles.courseLink}
                                                iconRight={
                                                    <Icon icon="arrow_next" />
                                                }
                                                onClick={() =>
                                                    window.open(
                                                        link?.link,
                                                        "_blank",
                                                        "noopener,noreferrer",
                                                    )
                                                }
                                                size="sm"
                                                title={link?.label}
                                                type="button"
                                                variant="secondary"
                                            >
                                                {link?.label}
                                            </Button>
                                        </li>
                                    );
                                },
                            )}
                        </ul>
                    </div>
                </Panel>
                <div className={`${styles.topics} k-content-section-topics`}>
                    {BUILDER_GUIDE?.topics?.map((topic, index) => {
                        return (
                            <Panel
                                className={`${styles.topicPanel} k-content-topic`}
                                density="comfortable"
                                key={`topic-${index}`}
                            >
                                <div
                                    className={`${styles.topicHeaderContainer} topic-header-container`}
                                >
                                    <div
                                        className={`${styles.topicHeader} topic-header`}
                                    >
                                        <Heading
                                            className={styles.cardTitle}
                                            level={4}
                                        >
                                            {topic?.title}
                                        </Heading>
                                        {topic?.link && (
                                            <Link
                                                className={`${styles.topicCms} topic-cms`}
                                                href={getLink(topic?.link)}
                                                iconRight={
                                                    <Icon icon="external-link" />
                                                }
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                underline="none"
                                                variant="primary"
                                            >
                                                View in Prismic
                                            </Link>
                                        )}
                                    </div>
                                    {/* <Button
                                        iconLeft={<Icon icon="accept-rounder" />}
                                        onClick={handlerCompleted}
                                        size="sm"
                                        variant={
                                            topic?.completed
                                                ? "primary"
                                                : "secondary"
                                        }
                                    >
                                        {topic?.completed ? "Done" : "Pending"}
                                    </Button> */}
                                </div>
                                <div className="pendo-content"></div>
                                {/* <div className={`${styles.topicBody} topic-body`}>
                                    <Heading level={5}>{topic?.title}</Heading>
                                    <Text tone="secondary" variant="body-sm">
                                        {topic?.description}
                                    </Text>
                                    <ul className={styles.assetList}>
                                        {topic?.assets?.map(
                                            (topLink, topIndex) => {
                                                return (
                                                    <Button
                                                        iconLeft={
                                                            topLink?.type ===
                                                            "video" ? (
                                                                <Icon icon="play-control" />
                                                            ) : undefined
                                                        }
                                                        iconRight={
                                                            <Icon icon="external-link" />
                                                        }
                                                        key={topIndex}
                                                        onClick={() =>
                                                            window.open(
                                                                topLink?.link,
                                                                "_blank",
                                                                "noopener,noreferrer",
                                                            )
                                                        }
                                                        size="sm"
                                                        variant={
                                                            topLink?.type ===
                                                            "video"
                                                                ? "primary"
                                                                : "secondary"
                                                        }
                                                    >
                                                        {topLink?.type ===
                                                        "video"
                                                            ? "Watch Video"
                                                            : "Read Guide"}
                                                    </Button>
                                                );
                                            },
                                        )}
                                    </ul>
                                </div> */}
                            </Panel>
                        );
                    })}
                </div>
            </div>
        </Content>
    );
};

export default BuilderGuide;
